




























































import { debounce } from 'lodash-es';
import { ref, defineComponent, toRefs, watch } from '@vue/composition-api';

const name = 'ttam-catalogs-preview-cta';
export default defineComponent({
  name,
  components: {},
  props: {
    productList: {
      type: Array,
      default: () => [],
    },
    remote: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { productList } = toRefs(props);
    const index = ref(0);
    const viSelect = ref();
    const viPopover = ref();
    const selectedVal = ref('');

    const emitQuery = debounce(val => emit('query', val), 200);
    const refreshRef = ref();

    const filterMethod = val => {
      emitQuery(val);
    };

    const onChange = item => emit('change', item);

    const onRefresh = () => {
      if (index.value >= productList.value.length) {
        index.value = 0;
      }
      onChange(productList.value[index.value++]);
      selectedVal.value = '';
      refreshRef.value.$el.blur();
    };

    watch(selectedVal, val => {
      const selected = productList.value?.find?.(item => (item as any).OuterID === val);
      if (selected) {
        viPopover.value?.doClose();
        onChange(selected);
      }
    });

    // watch(productList, () => {
    //   selectedVal.value = '';
    // });

    return {
      selectedVal,
      viSelect,
      viPopover,
      index,
      refreshRef,
      onChange,
      filterMethod,
      onRefresh,
    };
  },
});
